import * as Util from "../Utils/Util";
import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import ButtonMarker from "../Utils/ButtonMarker";

export default class PricingTableButton {
  private readonly element: HTMLElement;
  private readonly code: string;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.code = Util.getData(element, "strengthCode");
    element.addEventListener("click", () => this.send());
    Events.on("pricing-table-strength-changed", (code: string) => ButtonMarker.mark(element, code === this.code));
  }

  public send(): void {
    Events.fire("pricing-table-strength-changed", this.code);
  }

  public static Factory: DomFactory<PricingTableButton> = (e) => new PricingTableButton(e);
}
